import React from "react";

// Model Layout Component - Gender
const playBounce = (event, state) => {
  const el = event.currentTarget;
  el.classList.remove("map-hover-enter", "map-hover-leave");
  void el.offsetWidth;
  el.classList.add(state);
};

const bounceHandlers = {
  onMouseEnter: (e) => playBounce(e, "map-hover-enter"),
  onMouseLeave: (e) => playBounce(e, "map-hover-leave"),
};

const genderLayers = [
  {
    id: "gm1",
    src: "/assets/svgs/gender-svgs/mobile-svgs/gm1.svg",
    alt: "Gender",
    style: { left: "42.8%", top: "35.8%" },
  },
  {
    id: "gm2",
    src: "/assets/svgs/gender-svgs/mobile-svgs/gm2.svg",
    alt: "Gender",
    style: { left: "35%", top: "14%" },
  },
  {
    id: "gm3",
    src: "/assets/svgs/gender-svgs/mobile-svgs/gm3.svg",
    alt: "Gender",
    style: { left: "49.5%", top: "52.4%" },
  },
  {
    id: "gm4",
    src: "/assets/svgs/gender-svgs/mobile-svgs/gm4.svg",
    alt: "Gender",
    style: { left: "80%", top: "71%" },
  },
  {
    id: "gm5",
    src: "/assets/svgs/gender-svgs/mobile-svgs/gm5.svg",
    alt: "Gender",
    style: { right: "-35%", top: "27%" },
  },
  {
    id: "gm6",
    src: "/assets/svgs/gender-svgs/mobile-svgs/gm6.svg",
    alt: "Gender",
    style: { left: "79%", top: "48%" },
  },
];

const GenderMobileModel = ({ className = "", showTooltips = true }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const getScrollTarget = (layerId) => {
    const scrollMap = {
      gm2: "overview-gender-caregiving",
      gm5: "india",
      gm4: "nepal",
      gm3: "indonesia",
      gm6: "bangladesh",
    };
    return scrollMap[layerId];
  };

  return (
    <main className="relative pt-5 -mb-20">
      <section className="p-2">
        <div
          className={`relative mx-auto aspect-[4/7] max-w-[500px] ${className}`}
        >
          {genderLayers.map((layer) => {
            const interactive = layer.id !== "gm1";
            const hoverTiming = {
              "--map-seq-name": "mapSeqReveal",
              "--map-seq-duration": "1200ms",
              "--map-seq-delay": "0ms",
            };

            const tooltipPos = (() => {
              switch (layer.tooltipPlacement) {
                case "left":
                  return "left-full top-1/2 -translate-y-1/2 ml-2";
                case "right":
                  return "right-full top-1/2 -translate-y-1/2 mr-2";
                case "top":
                  return "bottom-full left-1/2 -translate-x-1/2 -mt-2";
                default:
                  return "top-full left-1/2 -translate-x-1/2 mt-2";
              }
            })();

            const scrollTarget = getScrollTarget(layer.id);
            const handleClick = scrollTarget
              ? () => scrollToSection(scrollTarget)
              : undefined;

            return (
              <div
                key={layer.id}
                className={`absolute -translate-x-1/2 -translate-y-1/2 ${
                  interactive ? "group" : ""
                }`}
                style={layer.style}
              >
                <div className="relative">
                  <img
                    src={layer.src}
                    alt={layer.alt}
                    loading="lazy"
                    className={`select-none max-w-max object-contain ${
                      interactive
                        ? "map-hover-bounce hover:cursor-pointer pointer-events-auto map-seq"
                        : "pointer-events-none"
                    }`}
                    style={interactive ? { ...hoverTiming } : undefined}
                    {...(interactive ? bounceHandlers : {})}
                    {...(handleClick ? { onClick: handleClick } : {})}
                  />
                  {interactive && layer.tooltip && showTooltips && (
                    <span
                      className={`pointer-events-none z-50 absolute rounded-md bg-[#FEFBF6] p-2 text-[11px] font-normal text-black text-nowrap opacity-0 transition-opacity duration-200 group-hover:opacity-100 ${tooltipPos}`}
                    >
                      {layer.tooltip}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default GenderMobileModel;
